var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCupLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 10L5.77076 19.2491C5.90033 20.804 7.20013 22 8.7604 22H15.2396C16.7999 22 18.0997 20.804 18.2292 19.2491L19 10H5ZM7.1736 12L7.76385 19.083C7.80704 19.6013 8.24031 20 8.7604 20H15.2396C15.7597 20 16.193 19.6013 16.2361 19.083L16.8264 12H7.1736Z",
    fill: "#12131A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14 16C14 17.1046 13.1046 18 12 18C10.8954 18 10 17.1046 10 16C10 14.8954 10.8954 14 12 14C13.1046 14 14 14.8954 14 16Z",
    fill: "#12131A"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.23806 6.57166L5.5822 4.5068C5.82329 3.06024 7.07486 2 8.54138 2H15.4586C16.9251 2 18.1767 3.06024 18.4178 4.5068L18.7619 6.57166C19.5122 7.11698 20 8.00153 20 9C20 10.6569 18.6569 12 17 12H7C5.34315 12 4 10.6569 4 9C4 8.00153 4.48779 7.11698 5.23806 6.57166ZM8.54138 4H15.4586C15.9475 4 16.3646 4.35341 16.445 4.8356L16.6391 6H7.36092L7.55499 4.8356C7.63535 4.35341 8.05254 4 8.54138 4ZM7 8C6.44772 8 6 8.44772 6 9C6 9.55228 6.44772 10 7 10H17C17.5523 10 18 9.55228 18 9C18 8.44772 17.5523 8 17 8H7Z",
    fill: "#12131A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCupLine);
export default __webpack_public_path__ + "static/media/cup-line.8a0ed1d150c5f993ff899f8e25c17167.svg";
export { ForwardRef as ReactComponent };